import IVendorClientConfigRequestData from '../server/requests/contracts/IVendorClientConfigRequestData';
import IBaseVendorGameConfig from '../../core/src/managers/contracts/configurations/game/IBaseVendorGameConfig';
import IGameGeneralConfig from '../../core/src/managers/contracts/configurations/IGeneralGameConfig';
import AbstractGameGeneralConfig from '../../core/src/baseConfigs/AbstractGameGeneralConfig';
import App from '../../core/src/App';

export default abstract class AbstractVendorGameGeneralConfig extends AbstractGameGeneralConfig implements IGameGeneralConfig<IVendorClientConfigRequestData>, IBaseVendorGameConfig {
  private _clientConfig: IVendorClientConfigRequestData;
  private defaultRtp: number = 2000;
  get clientConfig(): IVendorClientConfigRequestData {
    return this._clientConfig
  };
  parseClientConfig(data: IVendorClientConfigRequestData) {
    if (App.config.useClient3Api) {
      data.gameServerApi = `https://dev-casino-client3.api.relaxg.net/game`;
      data.tokenApi = `https://dev-casino-client3.api.relaxg.net/capi/2.0/casino/token/gettoken`
    }

    this._clientConfig = data;
  }

  parseRTP(rtp: number) {
    this.defaultRtp = rtp * 100;
  }

  getRTP(): number {
    let result: number;
    //  currently we have no info why getClientConfig is with wrong RTP. We must get it from rmlogin
    // if (this.clientConfig?.gameDetails?.RTP) {
    //   result = this.clientConfig.gameDetails.RTP
    // } else {
    //   result = this.defaultRtp;
    // }

    result = this.defaultRtp;
    return result;
  }
}
